import { render, staticRenderFns } from "./FormFieldsList.vue?vue&type=template&id=5d67f51f&scoped=true&"
import script from "./FormFieldsList.vue?vue&type=script&lang=js&"
export * from "./FormFieldsList.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldsList.vue?vue&type=style&index=0&id=5d67f51f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d67f51f",
  null
  
)

export default component.exports